import {React, useState, useEffect} from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import {Send} from "react-bootstrap-icons";
import {Button} from 'react-bootstrap';
import bannerImg from "../assets/banner-jai.GIF";
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export const Banner = () => {

    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(30 - Math.random() * 10);
    const [index, setIndex] = useState(1);
    const toRotate = [ "A Software Wizard", "A Data Science Maestro", "An Avid Tech Hobbyist", "Your Next Hire" ];
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
        tick();
        }, delta);

        return () => { clearInterval(ticker) };
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
        setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setIndex(prevIndex => prevIndex - 1);
        setDelta(period);
        } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setIndex(1);
        setDelta(500);
        } else {
        setIndex(prevIndex => prevIndex + 1);
        }
    }

  return (
    <section className='banner' id='home'>
        {/* <Container> */}
            <Row className="justify-content-between">
                <Col xs = {12} md = {6} xl = {7}>
                    <span className='tagline'>
                        Hi, Hello! Welcome!
                        <h1>
                            <span style={{color: 'black', fontWeight: 'bold'}}>{`I'm Jaideep Nuvvula`} </span>
                            <br />
                            <span className='wrap' style={{color: '#4169e1'}}>
                                {text}
                            </span>
                        </h1>
                        <p>
                            Code Today, Shape Tomorrow: A Symphony of Machine Learning and Diverse Tech Expertise.
                        </p>
                        <Button  className="ml-auto custom-button" onClick={() => window.location.href = 'https://drive.google.com/file/d/1Iv_njs_iTUo6wJYwi7cAH91DP_AB2H1-/view'}>    
                            Resume  <FontAwesomeIcon icon={faFile} style={{ margin: '0 10px' }}/>
                            
                        </Button>
                    </span>
                </Col>

                <Col xs = {12} md = {6} xl = {5} style={{ paddingLeft: '10%'}}>
                    <img src = {bannerImg} alt = "Header of Me" height="350" width="350" />
                </Col>
            </Row>
        {/* </Container> */}


    </section>
  )
}
